import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FLYING_APP_CONSTANTS } from '@apps-v2/flying/shared';
import { LEGAL_FLYING_PAGES } from '@domains/frontend/legal-and-policy';
import { ISparkFooterConfig } from '@domains/frontend/templates/spark';
import { WebHelperService } from '@libs/libraries/frontend';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterComponent {

	constructor(
		private webHelperService: WebHelperService
	) {}


	//** Configuration */
	readonly FOOTER_CONFIG: ISparkFooterConfig = {
		links: [
			...LEGAL_FLYING_PAGES.map((page) => ({
				label: page.title,
				link: this.webHelperService.getNavigatePathUrl(['legal', page.slug]),
				target: '_self' as const
			})),
			{
				label	: 'Support',
				link	: this.webHelperService.getNavigatePathUrl(['support'])
			}
		],
		company: FLYING_APP_CONSTANTS.LEGAL.COMPANY_NAME
	};
}
